import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Accordion, Grid, Header, Icon, Image, Label, List, Message, Segment } from "semantic-ui-react";
import  styles  from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/family/";
const iconRoute = process.env.REACT_APP_CDN_ROUTE + "/icons/";

const CrisisPlanningLearnMore: React.FC = () => {
  const [activeAccordionIndexes] = useState([0, 1]);

  const renderAccordionPlans = () => {
    return (
      <>       
        <Grid stackable className={styles.learnMoreFullDiv} >
          <Grid.Row columns='equal' stretched className={styles.highlightsItemRow} >
            <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}SupportIcon.png`} className={styles.highlightsItemHeaderImgIcon} />
                  <p className={styles.highlightsItemHeaderTitle} >SUPPORT NETWORK</p> 
                  <Header.Subheader>
                    <p className={styles.learnMoreAccordionText} > Create a personal support network of family and friends who will help in an emergency 
                      and include them in the plans. </p> 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column stretched container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}Reconnecting2.png`} className={styles.highlightsItemHeaderImgIcon} />
                  <p className={styles.highlightsItemHeaderTitle} >RECONNECTING PLANS</p>
                  <Header.Subheader > 
                    <p className={styles.learnMoreAccordionText}>Make sure everyone is clear as to where the older adult will go in case of a disaster and that 
                      everyone knows who they should contact to make sure everyone is accounted for.</p>
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
          </Grid.Row>
          <Grid.Row stretched columns='equal' className={styles.highlightsItemRow} >
            <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}transport-bus-front.png`} className={`${styles.highlightsItemHeaderImgIcon} ${styles.highlightsIconEnlarge}`} />
                  <p className={styles.highlightsItemHeaderTitle} >TRANSPORTATION</p>
                  <Header.Subheader>  
                    <p className={styles.learnMoreAccordionText} >Consider transportation options in the event of an evacuation. If the older adult has a pet, 
                      locate shelters that will offer assistance in the event of disasters.</p> 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}ExitIcon.png`} className={styles.highlightsItemHeaderImgIcon} />
                  <p className={styles.highlightsItemHeaderTitle} >TWO WAYS OUT </p>
                  <Header.Subheader> 
                    <p className={styles.learnMoreAccordionText} >Plan for two ways out of the older adult's home and make sure that exits are unobstructed.</p>
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}PhoneBookIcon.png`} className={styles.highlightsItemHeaderImgIcon} />
                  <p className={styles.highlightsItemHeaderTitle} >CONTACT REGISTRY</p> 
                  <Header.Subheader> 
                    <p className={styles.learnMoreAccordionText} >Contact the local emergency management office to see if there is a registry for older adults so they can be 
                      assisted quickly in a disaster.</p>
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </>
    );
  };
  const renderAccordionKit = () => {
    return (
      <>
      <Grid stackable doubling columns="equal" padded='vertically'>
        <Grid.Column width={9}>
          <Segment raised className={styles.highlightsItemWhiteBG} >  
            <div style={{width: '100%', height: '100%', display: "inline-block"}}>
              <p className={styles.learnMoreAccordionText} > <br/>
                After a natural disaster or emergency situation, the older adult may be stuck without resources for a 
                few days. It is a good idea to have an emergency kit prepared for these situations.
                <br/><br/>
                An emergency kit is a collection of basic household items that may be needed in the event that an emergency 
                or disaster situation strikes.</p>
              <p className={styles.learnMoreAccordionTextEmphasis} > 
                The emergency kit should be tailored to the older adult's needs and should be kept in a waterproof container 
                that is easily accessible.</p>
              <div className={styles.learnMoreQuoteBox}>
                <Icon name="key" className={styles.learnMoreTipTopLeftIcon} />
                <span className={styles.learnMoreQuoteBoxSpan}>
                  <Header className={styles.learnMoreTipHeaderWithTopLeftIcon} content="Keys for Success:" />
                  <p className={styles.learnMoreNoticeText} > Check with your local and state emergency for additional regional
                  emergency preparedness kit basics. </p>
                </span>
              </div>
            </div>
          </Segment>  
        </Grid.Column>
        <Grid.Column >
          <Segment raised className={styles.highlightsItemWhiteBG} >  
            <List divided relaxed bulleted className={styles.learnMoreBulletedList}  >
              <List.Header className={styles.learnMoreBulletedListHeader} >The Basics Should Include:</List.Header>
              <>
                <List.Item header="Food & Water" description="At least three-day's worth of food and water per person" />
                <List.Item header="Non-Electrical Light Sources" description="Flashlights and/or candles" />
                <List.Item header="Battery-Powered Radio" description="Include extra batteries so there is no 
                  concern of missing important news updates" />
                <List.Item header="First-aid kit" />
                <List.Item header="Pet supplies" description="Food, water, important documents, medications, pet tag with current 
                  information, picture of your pet(s) just in case they get lost, and carrier for small animals or leash for larger animals" />
                <List.Item header="Medications" description="A 30-day supply of medications and a detailed medication list." />
                <List.Item header="Important Documents" description="Insurance cards, Driver's License or other form of ID, etc. " style={{bottomBorder: "none"}}/>
              </>
            </List>
          </Segment>  
        </Grid.Column>
      </Grid>
      </>
    );
  };


  const accordions = [
    { key: 'plans',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Make A Plan For Emergencies </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionPlans()}/>)
      }
    },
    { key: 'kit',
      index: 1,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Put Together an Emergency Kit </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionKit()}/>)
      }
    },
  ];

  
  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}CrisisPlanningInfoTwoRight.jpg)`, }}>
        <div className={styles.learnMoreModalContent}>

          <div className={styles.learnMoreAccordionFullDivGrid} >
            <div className={styles.learnMoreAccordionFullDiv} >
              <Accordion panels={accordions} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionIndexes} exclusive={false} />
            </div> 
          </div>  

        </div>
      </Segment>      
    </>
  );  
};

export default observer(CrisisPlanningLearnMore);
